'use client';

import { useEffect } from 'react';

import { GraphQLResponse } from '../lib/types';

import { logGraphQLDebug } from './logGraphQLDebug';

/** React hook для автоматического логирования debug информации из GraphQL ответов */
export const useGraphQLDebug = <T>(
  response: GraphQLResponse<T> | undefined | null,
  operationName?: string
): void => {
  useEffect(() => {
    if (!response?.debugInfo) {
      return;
    }

    const isDev = process.env.NODE_ENV === 'development';
    const hasDebugCookie = document.cookie
      .split('; ')
      .some((cookie) => cookie === 'show_debug_info=1');

    if (isDev || hasDebugCookie) {
      logGraphQLDebug(response, operationName);
    }
  }, [response, operationName]);
};
